import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-record",
  "use": "icon-record-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 21 21\" id=\"icon-record\">\n    <path fill-rule=\"evenodd\" fill=\"rgb(237, 95, 77)\" d=\"M10.396,20.797 C4.883,20.797 0.414,16.328 0.414,10.815 C0.414,5.302 4.883,0.833 10.396,0.833 C15.909,0.833 20.378,5.302 20.378,10.815 C20.378,16.328 15.909,20.797 10.396,20.797 ZM10.396,1.907 C5.476,1.907 1.488,5.895 1.488,10.815 C1.488,15.735 5.476,19.723 10.396,19.723 C15.316,19.723 19.304,15.735 19.304,10.815 C19.304,5.895 15.316,1.907 10.396,1.907 ZM14.603,13.799 L10.338,11.337 C10.154,11.312 9.999,11.187 9.920,11.015 C9.868,10.918 9.848,10.803 9.864,10.687 L9.864,4.637 C9.864,4.314 10.108,4.051 10.409,4.051 C10.709,4.051 10.953,4.314 10.953,4.637 L10.953,10.434 L15.147,12.856 C15.386,12.994 15.458,13.316 15.307,13.577 C15.157,13.837 14.842,13.937 14.603,13.799 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/user/icons/svg/record.svg
// module id = 9q4B
// module chunks = 12